<template>
  <v-app class="container">
    <br>
    <v-card>
      <v-card-title v-if="gcontenido.length <= 0" class="grey lighten-4 change-font" primary-title>
        <div class="spinner-grow"></div>Cargando marco de referencia &#8230;
      </v-card-title>
      <v-card-title v-else class="grey lighten-4 change-font" primary-title>Marco de referencia</v-card-title>
      <v-card-text>
        <br>       
       <v-expansion-panels v-model="panel" >
    <v-expansion-panel
       v-for="contenido in gcontenido"
      :key="contenido.idcontenido"
    >
      <v-expansion-panel-header>{{contenido.titulo}}</v-expansion-panel-header>
      <v-expansion-panel-content>
      <template>
          <div v-html="body(contenido.descripcion)" ></div>
          <div v-html="foot(contenido.enlace)" v-if="contenido.enlace"></div>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
      </v-card-text>
    </v-card>
  </v-app>
</template>      
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {     
      panel: null
    };
  },
  computed: {
    ...mapGetters(["gcontenido"])
  },
  methods: {
    ...mapActions(["textosTodos"])
    ,
     body: function(cuerpo) {       
      var slot = this.$slots.default;
      if (typeof slot !== "undefined") {
        return slot;
      } else if (typeof cuerpo !== "undefined") {
        return cuerpo;
      } else return null;
    },
    foot: function(enlace) {
      var slot = this.$slots.default;
      if (typeof slot !== "undefined") {
        return slot;
      } else if (typeof enlace !== "undefined") {
        slot =
          "<a href='" +
          enlace +
          "' target='_blank' title='Más información...' class='text-link'><i class='icon-square-up-right'></i><b>Más información</b></a>";
        return slot;
      } else return null;
    }
  },
  created() {
    this.textosTodos();
  }
  ,
  watch:
  {
    gcontenido : function()
    {
      this.panel = 0
    }
  }
};
</script>